module.exports = __webpack_public_path__ + "static/media/tick-on-shield.06c34486.svg";